'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _browser = require('../../redux/modules/browser');

var _modal = require('../../redux/modules/modal');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propsComparer = require('../../utils/propsComparer');

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _redux = require('redux');

var _reactRedux = require('react-redux');

var _config = require('../../redux/modules/config');

var _urls = require('../../utils/urls');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CONSOLE_QUERY_PARAMS = 'htoolbar=no,resizable=yes,location=no,status=no,menubar=no,scrollbars=no,height=690,width=980';

var BidConsoleOpener = (_dec = (0, _reactRedux.connect)(function (state) {
    var baseUrl = (0, _config.getBaseUrl)(state);
    var mobile = (0, _browser.isUiMobile)(state);
    var browser = (0, _browser.getUiBrowser)(state);
    return { baseUrl: baseUrl, browser: browser, mobile: mobile };
}, function (dispatch) {
    return (0, _redux.bindActionCreators)({
        openDownloadMobileModal: _modal.openDownloadMobileModal,
        openInstallFlashModal: _modal.openInstallFlashModal
    }, dispatch);
}), _dec(_class = (_temp2 = _class2 = function (_Component) {
    (0, _inherits3.default)(BidConsoleOpener, _Component);

    function BidConsoleOpener() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, BidConsoleOpener);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = BidConsoleOpener.__proto__ || (0, _getPrototypeOf2.default)(BidConsoleOpener)).call.apply(_ref, [this].concat(args))), _this), _this.openBidConsole = function () {
            var _this$props = _this.props,
                browser = _this$props.browser,
                catalogId = _this$props.catalogId,
                baseUrl = _this$props.baseUrl,
                mobile = _this$props.mobile;


            if (mobile) {
                _this.props.openDownloadMobileModal();
            } else {
                if (browser.name === 'firefox') {
                    _this.props.openInstallFlashModal();
                }
                window.open((0, _urls.getCatalogConsoleUrl)(baseUrl, catalogId), '/bidapplet' + catalogId, CONSOLE_QUERY_PARAMS);
            }
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(BidConsoleOpener, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['catalogId', 'mobile']);
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.cloneElement(_react.Children.only(this.props.children), {
                onClick: this.openBidConsole
            });
        }
    }]);
    return BidConsoleOpener;
}(_react.Component), _class2.defaultProps = {
    catalogId: 0,
    children: '',
    mobile: ''
}, _temp2)) || _class);
exports.default = BidConsoleOpener;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/BidConsoleOpener/BidConsoleOpener.js
// module id = k+pu
// module chunks = 46